import { defineStore } from 'pinia';
import http from '@/core/http';

export const statisticStore = defineStore('statistic', {
  actions: {
    GetIndexInfo() {
      return http.req_get('/admin/action/index', { ajax: 1 });
    },
    // 行业数据
    GetIndustryData(payload) {
      return http.req_get('/admin/trend/tradedata', { ajax: 1, ...payload }, { timeout: 60000 });
    },
    // 平台统计
    GetStatics(payload) {
      return http.req_get('/admin/trend/platform', { ajax: 1, ...payload }, { timeout: 60000 });
    },
    // 门店情况统计
    GetStoreStateDatas(payload) {
      return http.req_get('/admin/trend/getstorestatus', { ajax: 1, ...payload }, { timeout: 60000 });
    },
    // 获取用户下单时地理位置分布
    GetUserOrderGeo(payload) {
      return http.req_get('/admin/trend/getstoreuserordermap', { ajax: 1, ...payload }, { timeout: 60000 });
    },
  }
});